let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4cmQH")).then(() => parcelRequire('6GlkH'));